import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const HeartIcon = (props: IconProps) => (
  <ChakraIcon viewBox="13.00 16.50 37.00 37.00" {...props}>
    <path d="M39.4610998,20 C33.5068997,20 31.5,25.2614711 31.5,25.2614711 C31.5,25.2614711 29.4943246,20 23.5388995,20 C17.5860994,20 14,25.6492355 14,30.3048465 C14,38.1071671 31.5,50 31.5,50 C31.5,50 49,38.1109995 49,30.3062401 C49,25.6492355 45.4166999,20 39.4610998,20 Z" fill="currentColor" fillRule="evenodd" />
  </ChakraIcon>
)

export default HeartIcon
